import React, { useMemo } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Progress from "react-svg-progress";
import moment from "moment";
import I18n from "i18n-js";

import DateInput from "../../../commons/DateInput";

import Input from "../Input";
import FormSection from "./FormSection";
import ObjectivesAndTasks from "./ObjectivesAndTasks";
import TimeWithVicky from "./TimeWithVicky";

import { defaultObjective } from "./ObjectiveList";

import planSchema from "../../config/validation/plan";

const formatDate = (date) => moment.utc(date).local().format("YYYY-MM-DD");

const getDefaultValues = (plan) => ({
  title: plan?.title || "",
  start_date: plan?.start_date || null,
  target_date: plan?.target_date || null,
  objectives: plan?.objectives || [defaultObjective(1)],
  time: plan?.time,
  frequency: plan?.frequency || "1",
  periodicity: plan?.periodicity || "week",
  repeat: plan?.repeat || [],
  ending: {
    type: "manual",
    after: "4",
    ...plan?.ending,
    on: plan?.ending?.on ? formatDate(plan?.ending?.on) : null
  }
});

const PlanForm = ({ team, edit, plan, loading, hourStyle, onSaveClick, onCancelClick }) => {

  const defaultValues = useMemo(() => getDefaultValues(plan));
  const schema = planSchema(I18n.t("pdp.form"));
  const form = useForm({ defaultValues, resolver: yupResolver(schema) });
  const { control, watch, handleSubmit, formState: { errors } } = form;

  console.log(watch(), errors);

  const handleCancelClick = (event) => {
    event.preventDefault();
    onCancelClick && onCancelClick();
  }

  return (
    <FormProvider {...form} defaultValues={defaultValues}>
      <form onSubmit={handleSubmit(onSaveClick)}>
        <div className="title">
          {edit ? I18n.t("pdp.form.title.edit") : I18n.t("pdp.form.title.create")}
        </div>
        <FormSection>
          <div className="pdp-form-row">
            <Controller
              name="title"
              control={control}
              render={({ field: { ref, ...props } }) => (
                <Input
                  placeholder={I18n.t("pdp.form.plan.fields.title.name")}
                  error={errors.title?.message}
                  inputRef={ref}
                  {...props}
                />
              )}
            />
            <div className="dummy" />
          </div>
        </FormSection>
        <div className="separator" />
        <FormSection
          title={I18n.t("pdp.form.timeframe.title")}
          description={I18n.t("pdp.form.timeframe.description")}
        >
          <div className="pdp-form-row">
            <Controller
              name="start_date"
              control={control}
              render={({ field: { ref, ...props } }) => (
                <DateInput
                  placeholder={I18n.t("pdp.form.timeframe.fields.start_date.name")}
                  error={errors.start_date?.message}
                  inputRef={ref}
                  {...props}
                />
              )}
            />
            <Controller
              name="target_date"
              control={control}
              render={({ field: { ref, ...props } }) => (
                <DateInput
                  placeholder={I18n.t("pdp.form.timeframe.fields.target_date.name")}
                  error={errors.target_date?.message}
                  inputRef={ref}
                  {...props}
                />
              )}
            />
          </div>
        </FormSection>
        <div className="separator" />
        <ObjectivesAndTasks team={team}  />
        <div className="separator" />
        <TimeWithVicky hourStyle={hourStyle} />
        <div className="buttons">
          <button
            className="cancel-btn"
            disabled={loading}
            onClick={handleCancelClick}
          >
            {I18n.t("common.cancel")}
          </button>
          <button
            type="submit"
            className={`save-btn ${loading ? "loading" : ""}`}
            disabled={loading}
          >
            <span className="content">
              {edit ? I18n.t("pdp.form.actions.save") : I18n.t("pdp.form.actions.create")}
            </span>
            <Progress color="#FFFFFF" size="15px" />
          </button>
        </div>
      </form>
    </FormProvider>
  );
}

export default PlanForm;
